<small class='error' *ngIf='errorMessage !== null'>{{errorMessage}}</small>


// WEBPACK FOOTER //
// ./src/components/+utils/error_messages/error_messages.ts.ErrorMessagesComponent.html